import type { ICustomShadowProperties } from '@themes/types/theme';

import { alpha, type Theme } from '@mui/material/styles';

import {
  CUSTOM_SHADOW_ALPHA_OUTLINE,
  CUSTOM_SHADOW_ALPHA_TABLE_BODY,
  CUSTOM_SHADOW_ALPHA_TABLE_ROW,
  CUSTOM_SHADOW_ALPHA_Z1_LIGHT,
} from '@themes/constants';

const CustomShadows = (theme: Theme): ICustomShadowProperties => ({
  text: `0 -1px 0 rgb(0 0 0 / 12%)`,
  grey: `0 0 0 2px ${alpha(theme.palette.grey[500], CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  info: `0 0 0 2px ${alpha(theme.palette.info.main, CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  error: `0 0 0 2px ${alpha(theme.palette.error.main, CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  success: `0 0 0 2px ${alpha(theme.palette.success.main, CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  warning: `0 0 0 2px ${alpha(theme.palette.warning.main, CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  primary: `0 0 0 2px ${alpha(theme.palette.primary.main, CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  greyButton: `0 14px 12px ${alpha(theme.palette.grey[500], CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  infoButton: `0 14px 12px ${alpha(theme.palette.info.main, CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  errorButton: `0 14px 12px ${alpha(theme.palette.error.main, CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  secondary: `0 0 0 2px ${alpha(theme.palette.secondary.main, CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  iconButton: `0 20px 20px ${alpha(theme.palette.primary.darker, CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  tableRow: `0 0 10px 7px ${alpha(theme.palette.primary.darker, CUSTOM_SHADOW_ALPHA_TABLE_ROW)}`,
  successButton: `0 14px 12px ${alpha(theme.palette.success.main, CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  warningButton: `0 14px 12px ${alpha(theme.palette.warning.main, CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  primaryButton: `0 14px 12px ${alpha(theme.palette.primary.main, CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  tableBody: `inset 0 0 14px ${alpha(theme.palette.primary.darker, CUSTOM_SHADOW_ALPHA_TABLE_BODY)}`,
  secondaryButton: `0 14px 12px ${alpha(theme.palette.secondary.main, CUSTOM_SHADOW_ALPHA_OUTLINE)}`,
  button:
    theme.palette.mode === 'dark'
      ? `0 2px 0 rgb(0 0 0 / 5%)`
      : `0 2px #0000000b`,
  z1:
    theme.palette.mode === 'dark'
      ? `0px 1px 1px rgb(0 0 0 / 14%), 0px 2px 1px rgb(0 0 0 / 12%), 0px 1px 3px rgb(0 0 0 / 20%)`
      : `0px 1px 4px ${alpha(theme.palette.grey[900], CUSTOM_SHADOW_ALPHA_Z1_LIGHT)}`,
});

export default CustomShadows;
